const mandatoryFields = ['first_name', 'last_name'];

export default mandatoryFields;
